import { Modal } from '../../../components/modal/modal';
import { useState } from 'react';
import { Button } from '../../../components/form/button';
import { Spinner } from '../../../components/spinner/spinner';
import { toast } from '../../../util/toasts';
import { ValidationError } from '../../../components/validation-error/validation-error';
import classNames from 'classnames';
import { usePurchaseOrderApiV1 } from '../../../clients/quipli-service/purchase-order/purchase-order-api-v1';
import { PurchaseOrder } from '../../../clients/quipli-service/purchase-order/purchase-order';

export const ApprovePurchaseOrder = ({
  order,
  onCancel,
  onComplete,
}: {
  order: PurchaseOrder;
  onCancel: () => void;
  onComplete: () => void;
}) => {
  const { approvePurchaseOrder } = usePurchaseOrderApiV1();

  const [isApproving, setIsApproving] = useState<boolean>(false);
  const [canApprove, setCanApprove] = useState<{ isValid: boolean; errors: string[] }>();

  async function doApprove() {
    try {
      setIsApproving(true);

      // TODO: Implement this function
      setCanApprove({ isValid: true, errors: [] });

      await approvePurchaseOrder(order.id);
      onComplete();
    } catch (err: any) {
      toast(err.message, 'error');
    } finally {
      setIsApproving(false);
    }
  }

  return (
    <Modal
      isOpen={true}
      title="Approve Purchase Order"
      actions={
        !order || isApproving ? null : (
          <>
            <Button className="button button-secondary" onClick={() => onCancel()}>
              Cancel
            </Button>
            <Button
              dataCy="approve-purchase-order-modal"
              className="button button-yellow"
              // disabled={!isValid}
              onClick={() => doApprove()}
            >
              Approve
            </Button>
          </>
        )
      }
      close={() => onCancel()}
    >
      {isApproving ? (
        <Spinner />
      ) : (
        <div className="flex flex-column w-full">
          <ValidationError
            className={classNames({ hidden: canApprove?.isValid !== true })}
            style={{ maxWidth: '342px' }}
          >
            <ul>{/* TODO: add possible errors  */}</ul>
          </ValidationError>
        </div>
      )}
    </Modal>
  );
};
